import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as baggageActions from './../../../../actions/baggageAction';
import Baggage from './Baggage';

const mapStateToProps = state => {
    return {
        baggageState: state.baggageReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListBaggages: (filters) => dispatch(baggageActions.getListBaggages(filters)),
        deleteBaggageDetail: (baggage, filters) => dispatch(baggageActions.deleteBaggageDetail(baggage, filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Baggage));
